import { observer } from "mobx-react-lite";
import { AudioCaptureIndicator } from "@/components/layout/components/AudioCaptureIndicator";
import { VoiceActions } from "@/components/note/floating-actions/VoiceActions";
import { MemCommonEditorStore } from "@/components/note/store/MemCommonEditorStore";
import { useCallback, useRef, useState } from "react";
import { MdsIconKind } from "@/design-system/components/icon";
import { MDSPopover } from "@/mds";

interface VoiceIndicatorProps {
  editorStore: MemCommonEditorStore;
}
export const VoiceIndicator = observer(({ editorStore }: VoiceIndicatorProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const ref = useRef<HTMLButtonElement>(null);

  const handleRequestClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const shouldCloseOnInteractOutside = useCallback((element: Element | null) => {
    if (element?.closest?.(".voice-actions-dropdown")) {
      return false;
    }
    return true;
  }, []);

  return (
    <>
      <AudioCaptureIndicator
        ref={ref}
        insideNote={true}
        onClickElse={() => setIsOpen(isOpen => !isOpen)}
        rightIconKind={isOpen ? MdsIconKind.AngleDown : MdsIconKind.AngleUp}
      />
      {editorStore && (
        <MDSPopover
          styling={false}
          triggerRef={ref}
          isOpen={isOpen}
          onOpenChange={setIsOpen}
          isNonModal={true}
          shouldCloseOnInteractOutside={shouldCloseOnInteractOutside}
        >
          <div data-voice-actions-root>
            <VoiceActions editorStore={editorStore} onRequestClose={handleRequestClose} />
          </div>
        </MDSPopover>
      )}
    </>
  );
});
